type KeyOfNested<T> = T extends object
  ? T extends readonly unknown[] | ((...args: never[]) => unknown) | Date
    ? never
    : {
        [K in keyof T]-?: K extends string ? `${K}` | `${K}.${KeyOfNested<T[K]>}` : never;
      }[keyof T]
  : never;

export const nameof = <T>(name: KeyOfNested<T>): string => name;
